<div class="centered-container is-width-{{ width() }}">
    <ng-content></ng-content>
</div>
